import {
  EffectiveOperationPermissionsArray,
  OperationName,
  OperationPermissionConfig,
} from '../types';

/**
 * For cases where we cannot determine the permissions, we assume that everything
 * is not allowed
 */
export function defaultNoPermission(
  permissionConfig: OperationPermissionConfig
): EffectiveOperationPermissionsArray {
  return Object.keys(permissionConfig).map((permissionName: OperationName) => [
    permissionName,
    false,
  ]);
}
